import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import {
  HomeFilled,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardFilled,
  CustomerServiceFilled,
  SettingFilled,
  MergeFilled,
  ProfileFilled,
  LogoutOutlined,
  ApiFilled,
  PieChartFilled,
  RobotFilled,
  CaretDownOutlined,
  CalculatorFilled,
  UserOutlined,
  SettingOutlined,
  UsergroupAddOutlined,
  SafetyCertificateOutlined,
  FileTextFilled,
  ApartmentOutlined
} from '@ant-design/icons';
import { Col, Row, Avatar, Button, Layout, Menu, theme, Dropdown, Tooltip, Divider } from 'antd';
import { 
  getDashboardGeneral, 
} from '../../API/dashboard';
import { handleOpenFile } from '../../API/utils';
import { useAuth } from "../Context/AuthContext";
import SearchBar from './components/SearchBar/SearchBar';
import FAQModal from '../Common/FAQModal/FAQModal';
import logoNav from "./assets/logo-nav.svg";
import isoNav from "./assets/iso-nav.svg";
import chainIcon from "./assets/chain.png";
import './Navbar.css'; 

const { Sider } = Layout;

const Navbar = (props) => {
  const {
    onLogout,
    collapsed,
    setCollapsed
  } = props;

  //const {token: { colorBgContainer }} = theme.useToken();
  const navigate = useNavigate();
  const location = useLocation();
  const restrictedRoutes = ['dashboard', 'assignment', 'settings', 'licences', 'userprofile'];
  const isInRestrictedRoute = restrictedRoutes.some(route => location.pathname.includes(route));

  const { hasPermission, userData, logout } = useAuth();
  // Consulta permisos: Superusuario  
  const isSuperuser = userData?.is_superuser === true;
  // Consulta permisos: Tiene rol asignado  
  const hasAnyRole = userData?.roles?.length > 0;
  // Consulta especifica de permisos
  const canAssetsRead = userData ? hasPermission("assets", "read") : false;
  const canDependenciesRead = userData ? hasPermission("dependencies", "read") : false;
  const canControlsRead = userData ? hasPermission("controls", "read") : false;
  const canAssignmentRead = userData ? hasPermission("assignment", "read") : false;
  const canEvaluationRead = userData ? hasPermission("evaluation", "read") : false;
  const canGapsRead = userData ? hasPermission("gaps", "read") : false;
  const canTasksRead = userData ? hasPermission("tasks", "read") : false;

  // Estados componente
  const [selectedKey, setSelectedKey] = useState(localStorage.getItem('selectedKey') || '1');
  const [userInitials, setUserInitials] = useState('');
  const [userPhotoUrl, setUserPhotoUrl] = useState(null);
  const [faqVisible, setFaqVisible] = useState(false);
  const [dashboardGeneral, setDashboardGeneral] = useState({});

  // Informacion del usuario
  //const dataUser = JSON.parse(localStorage.getItem('userData'));
  
  useEffect(() => {
    if (userData?.first_name && userData?.last_name) {
      setUserInitials(userData.first_name[0] + userData.last_name[0]);
    } else {
      setUserInitials('');
    }

    if (userData?.photo_url) {
      (async () => {
        const blobUrl = await handleOpenFile(userData.photo_url, 'image');
        setUserPhotoUrl(blobUrl);
      })();
    } else {
      setUserPhotoUrl(null);
    }
  }, [userData]);

  useEffect(() => {
    const fetchDashboardGeneral = async () => {
      try {
        const response = await getDashboardGeneral();
        setDashboardGeneral(response);

        // Guardar en localStorage
        localStorage.setItem(
          'dashboardGeneral',
          JSON.stringify(response)
        );
      } catch (error) {
        console.error('Error al obtener dashboard general', error);
      }
    };

    fetchDashboardGeneral();
  }, []);

   // Manejar el logout
   const handleLogout = () => {
    //localStorage.clear();
    logout();
    onLogout();
    navigate('/login');
  };

  // Manejar clic en un ítem del menú
  const handleMenuClick = (e) => {
    setSelectedKey(e.key);
    localStorage.setItem('selectedKey', e.key);
  };

  useEffect(() => {
    // Al colapsar/expandir el menú, restaurar la clave seleccionada
    setSelectedKey(localStorage.getItem('selectedKey') || '1');
  }, [collapsed]);

  const hasAssets = dashboardGeneral?.assets?.count > 0;
  const hasDependencies = dashboardGeneral?.dependencies?.count > 0;

  const canSeeAssets =
    isSuperuser ||
    (hasAnyRole && canAssetsRead) ||
    hasAssets;

  const canSeeDependencies =
    isSuperuser ||
    (hasAnyRole && canDependenciesRead) ||
    hasDependencies;

  return (
    <Layout className="layout-navbar">
      {/* Navbar vertical */}
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className="sider-navbar"
      >
        <div className="logo">
          <Link to="/home">
            <img
              src={collapsed ? isoNav : logoNav}
              alt="Logo"
              className="logo-img"
            />
          </Link>
        </div>

        <Menu
          className="menu"
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          onClick={handleMenuClick}
        >
          <Menu.Item key="1" icon={<HomeFilled/>}>
            <Link to="/home">Home</Link>
          </Menu.Item>

          <Menu.Item
            key="2"
            icon={<DashboardFilled />}
            disabled={!isSuperuser && (!hasAnyRole)}
            onClick={() => { navigate('/dashboard'); }}
              /* if (isSuperuser || canDashRead) {
                navigate('/dashboard');
              }
            }} */
          >
            Tablero de Gestión
          </Menu.Item>

          <Menu.Item
            key="3"
            icon={<ApiFilled />}
            /* disabled={!isSuperuser && (!hasAnyRole || !canAssetsRead)}
            onClick={() => {
              if (isSuperuser || canAssetsRead)  {
                navigate('/assets');
              }
            }} */
            disabled={!canSeeAssets}
            onClick={() => {
              if (canSeeAssets) {
                navigate('/assets');
              }
            }}
          >
            Inventario de Activos Críticos
          </Menu.Item>

          <Menu.Item
            key="4"
            icon={
              <img
                src={chainIcon}
                alt="Dependencias"
                //className={!isSuperuser && (!hasAnyRole || !canDependenciesRead) ? 'icon-disabled' : ''}
                className={!canSeeDependencies ? 'icon-disabled' : ''}
                style={{ filter: "invert(1)", width: 18, height: 18 }}
              />
            }
            /* disabled={!isSuperuser && (!hasAnyRole || !canDependenciesRead)}
            onClick={() => {
              if (isSuperuser || canDependenciesRead) {
                navigate('/dependencies');
              }
            }} */
            disabled={!canSeeDependencies}
            onClick={() => {
              if (canSeeDependencies) {
                navigate('/dependencies');
              }
            }}
          >
           Inventario de Dependencias
          </Menu.Item>

          <Menu.Item
            key="5"
            icon={<ProfileFilled />}
            disabled={!isSuperuser && (!hasAnyRole || !canControlsRead)}
            onClick={() => {
              if (isSuperuser || canControlsRead) {
                navigate('/controls');
              }
            }}
          >
            Inventario de Controles
          </Menu.Item>

          <Menu.Item
            key="6"
            icon={<MergeFilled />}
            disabled={!isSuperuser && (!hasAnyRole || !canAssignmentRead)}
            onClick={() => {
              if (isSuperuser || canAssignmentRead) {
                navigate('/assignment');
              }
            }}
          >
            Asignación de Controles
          </Menu.Item>

          <Menu.Item
            key="7"
            icon={<CalculatorFilled />}
            disabled={!isSuperuser && (!hasAnyRole || !canEvaluationRead)}
            onClick={() => {
              if (isSuperuser || canEvaluationRead) {
                navigate('/evaluation');
              }
            }}
          >
            Evaluación de Controles
          </Menu.Item>

          <Menu.Item
            key="8"
            icon={<PieChartFilled />}
            disabled={!isSuperuser && (!hasAnyRole || !canGapsRead)}
            onClick={() => {
              if (isSuperuser || canGapsRead) {
                navigate('/gaps');
              }
            }}
          >
            Gaps
          </Menu.Item>

          <Menu.Item
            key="9"
            icon={<FileTextFilled />}
            disabled={!isSuperuser && (!hasAnyRole || !canTasksRead)}
            onClick={() => {navigate('/tasks');}}
          >
            Tareas
          </Menu.Item>

          <Menu.Item
            key="10"
            icon={<ApartmentOutlined />}
            // TODO: Agregar validación de permisos de processes cuando exista en el backend.
            onClick={() => { navigate('/processes'); }}
          >
            Procesos
          </Menu.Item>

          {/* <Menu.Item key="9" icon={<SettingFilled />}>
            <Link to="/settings">Configuraciones</Link>
          </Menu.Item> */}
        </Menu>

        {/* Botón de colapso */}
        {/* <div className="collapse-btn">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
          />
        </div> */}
      </Sider>

      {/* Navbar horizontal */}
      <Layout style={{ marginLeft: collapsed ? 80 : 200, transition: 'margin-left 0.3s' }}>
        <Row 
          className={`top-bar ${collapsed ? 'collapsed' : ''}`} 
          align="middle"
          wrap={false}
        >
          {/* Columna del Buscador (flexible) */}
          <Col flex="auto" className="search-col">
            <div className="search-container">
              <span className="search-label">Buscar</span>
              <div className="vertical-line"></div>
              <SearchBar />
            </div>
          </Col>

          {/* Columna de Acciones (ancho fijo según contenido) */}
          <Col flex="none" className="actions-col">
            <div className="actions-container">
              {/* Botones de Ayuda */}
              {!isInRestrictedRoute ? (
                <Tooltip title="ASSETIA">
                  <Button
                    className="help-button"
                    onClick={() => {
                      const element = document.getElementById('assetia-section');
                      if (element) {
                        window.scrollTo(0, 0);
                        setTimeout(() => {
                          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }, 50);
                      }
                    }}
                  >
                    <RobotFilled style={{ color: 'white' }} />
                  </Button>
                </Tooltip>
              ) : (
                <Button className="assetia-off">
                  <RobotFilled style={{ color: 'white' }} />
                </Button>
              )}
              <Tooltip title="FAQs">
                <Button className="help-button" onClick={() => setFaqVisible(true)}>
                  <CustomerServiceFilled style={{ color: 'white' }} />
                </Button>
              </Tooltip>
              
              {/* Separador visual opcional */}
              <Divider type="vertical" style={{ height: '25px', marginLeft: '15px', marginRight: '10px' }} />

              {/* Avatar con menú desplegable */}
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item key="profile" icon={<UserOutlined className="menu-icon" />} onClick={() => navigate('/userprofile')}>
                      Perfil
                    </Menu.Item>
                    {isSuperuser && (
                      <>
                        <Menu.Item key="security" icon={<UsergroupAddOutlined className="menu-icon" />} onClick={() => navigate('/user-management')}>
                          Gestión de Usuarios
                        </Menu.Item>
                        <Menu.Item key="settings" icon={<SettingOutlined className="menu-icon" />} onClick={() => navigate('/settings')}>
                          Configuraciones
                        </Menu.Item>
                        <Menu.Item key="licences" icon={<SafetyCertificateOutlined className="menu-icon" />} onClick={() => navigate('/licences')}>
                          Licencias
                        </Menu.Item>
                      </>
                    )}
                    <Divider style={{ margin: '4px 0' }} />
                    <Menu.Item key="logout" icon={<LogoutOutlined className="menu-icon" />} onClick={handleLogout}>
                      Cerrar sesión
                    </Menu.Item>
                  </Menu>
                }
                trigger={['click']}
              >
                <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <Avatar
                    className={userPhotoUrl ? 'avatar-photo' : 'avatar-initials'}
                    src={userPhotoUrl}
                  >
                    {!userPhotoUrl && userInitials}
                  </Avatar>

                  <Tooltip
                    title={
                      userData?.first_name && userData.first_name.length > 15
                        ? userData.first_name
                        : null
                    }
                  >
                    <span className="user-text">
                      Hola, {userData?.first_name
                        ? userData.first_name.length > 15
                          ? `${userData.first_name.slice(0, 15)}`
                          : userData.first_name
                        : ''}
                    </span>
                  </Tooltip>
                  <CaretDownOutlined style={{ color: '#006939', marginLeft: '5px' }} />
                </div>
              </Dropdown>
            </div>
          </Col>
        </Row>
      </Layout>

      {/* Modal FAQs */}
      <FAQModal visible={faqVisible} onClose={() => setFaqVisible(false)} />
    </Layout>
  );
};

export default Navbar;
